import { render, staticRenderFns } from "./GtsGrid.vue?vue&type=template&id=78850a7c&scoped=true"
import script from "./GtsGrid.vue?vue&type=script&lang=js"
export * from "./GtsGrid.vue?vue&type=script&lang=js"
import style0 from "./GtsGrid.vue?vue&type=style&index=0&id=78850a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78850a7c",
  null
  
)

export default component.exports